module.exports = __webpack_public_path__ + "static/media/icon-terms.7337d61d.svg";